<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div>
        <a class="navbar-brand" href="#">
          <img src="../../assets/lightkey_logo.png" alt style="max-width: 60px" />
        </a>
      </div>

      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
          <li id="nav-key-item" class="nav-item">
            <router-link to="/dashboard/view-users" class="nav-link nav-style" exact>{{$t('dashboardUser')}}</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/dashboard/add-access-user" class="nav-link nav-style" exact>{{$t('dashboardAddAccessUser')}}</router-link>
            <div class="marcador"></div>
          </li>
          <li id="nav-key-item" class="nav-item">
            <router-link to="/dashboard/add-user" class="nav-link nav-style" exact>{{$t('dashboardAddUser')}}</router-link>
          </li>
          <li id="nav-key-item" class="nav-item">
            <router-link to="/dashboard/add-shift" class="nav-link nav-style" exact>{{$t('dashboardAddShift')}}</router-link>
          </li>
          <li class="nav-key-item">
            <router-link to="/dashboard/update-user" class="nav-link nav-style" exact>{{$t('dashboardEditUser')}}</router-link>
          </li>
          <!-- TODO: No Borrar -->

          <!-- <li class="nav-item">
            <router-link to="/dashboard/pricing" class="nav-link">Pricing</router-link>
          </li>-->
          <!-- <li class="nav-item">
            <router-link to="/dashboard/home" class="nav-link">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/dashboard/buy-keys" class="nav-link">Buy</router-link>
          </li>-->
        </ul>
        <div class="navbar-brand--left">
          <div class="navbar-brand--dropdown">
            <b-dropdown :text="language.toUpperCase()">
              <b-dropdown-item  class="button-flag"  v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)"> 
              <div v-if="language!=entry.language"><flag :iso="entry.flag" v-bind:squared=false /> {{entry.language.toUpperCase()}}</div>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="navbar-brand--logout">
            <a href="#" @click="logout()">  
              <img src="../../assets/icons8-exit-64.png">
            </a>
          </div>
        </div>  
        <div id="key-counter" v-if="false" class="nav-item">
          <a href class="key-cart">
            <img
              class="key-img"
              src="../../assets/key.svg"
              alt
              style=" max-width: 20px; max-height: 20px; margin-right: 5px;"
            />
            <span>5</span>
          </a>
        </div>
      </div>
    </nav>

    <router-view></router-view>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';
export default {
    data(){
      return{
        refresh:0,
        language:localStorage.getItem('language'),
        languages: [{ 
                      flag: 'gb', 
                      language: 'en', 
                      title: 'English' 
                    },
                    { flag: 'es', 
                      language: 'es', 
                      title: 'Español' },
                    { flag: 'de',
                      language: 'de',
                      title: 'Deutsch'}]
      };
    },
    methods: {
        logout(){

          //var language=localStorage.getItem('language');
          //console.log(language);
          // console.log({ login });
          // console.log({ user });
          //var mytitle=i18n.messages.language;
          //console.log(mytitle);
          switch(i18n.locale){
              case "en":
                    this.$swal
                    .fire({
                      title: i18n.messages.en.logoutTextTitle,
                      type: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      cancelButtonText: i18n.messages.en.logoutTextCancelOption,
                      confirmButtonText: i18n.messages.en.logoutTextOption
                    })
                    .then(result => {
                      if (result.value) {
                            console.log("INGLES");
                            localStorage.clear();
                            this.$router.replace("/");
                    }})
                  break;
              case "es":
                    this.$swal
                    .fire({
                      title: i18n.messages.es.logoutTextTitle,
                      type: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      cancelButtonText: i18n.messages.es.logoutTextCancelOption,
                      confirmButtonText: i18n.messages.es.logoutTextOption
                    })
                    .then(result => {
                      if (result.value) {
                            console.log("Español");
                            localStorage.clear();
                            this.$router.replace("/");
                    }})
                  break;
              case "de":
                    this.$swal
                    .fire({
                      title: i18n.messages.de.logoutTextTitle,
                      type: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      cancelButtonText: i18n.messages.de.logoutTextCancelOption,
                      confirmButtonText: i18n.messages.de.logoutTextOption
                    })
                    .then(result => {
                      if (result.value) {
                            console.log("Aleman");
                            localStorage.clear();
                            this.$router.replace("/");
                    }})
                  break;  
          }
        },
        changeLocale(locale) {        
          i18n.locale = locale;
          console.log(this.image);
          this.language=locale;
          console.log(this.image);
          localStorage.setItem("language",locale);
          
        } 
    }
}
</script>

<style>
.key-cart {
  display: flex;
}

#key-counter {
  margin-right: 50px;
}
.nav-style{
  border-top: 5px solid rgb(248,249,250);
}
.nav-style:hover {
  border-top: 5px solid green;
  padding-bottom: 0;
}
.nav-style.router-link-active{
  border-top: 5px solid green;
}

#navbarNav {
  display: flex !important;
  justify-content: space-between;
  margin-left: 30%;
}

.navbar-nav {
  display: grid !important;
  grid-template-columns: repeat(5, 1fr);
}
.navbar-brand--left{
  display:grid;
  grid-template-columns: repeat(2,50%);
  grid-gap: 20%;
}
.navbar-nav--dropdown{
  grid-column: 0/1;
}
@media (max-width: 1024px) {
  .navbar-nav {
    margin-left: calc(50% - 100px);
    grid-gap: 20px;
  }
  .navbar-brand--left{
    margin-left:10%;
  }
  #navbarNav {
    position: absolute;
    margin-left: 15%;
  }
  #nav-key-item {
    width: 80px;
  }
}

@media (max-width: 480px) {
  .navbar-nav {
    margin-left: calc(50% - 80px);
    grid-gap: 10px;

  }
  #navbarNav {
    position: absolute;
    margin-left: 10%;
  }
  #nav-key-item {
    width: 80px;
  }
  .navbar-brand--left{
    margin-left:7%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue